import React from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { RecordingPreview } from '@pages/RecordingPreview';
import { useCallRecordingControllerGetCallRecordingQuery } from '@shared/services/apiService/apiService';
import { useAppSelector } from '@shared/store';
import { selectors } from '@shared/store/ducks/auth';
import { AuthenticatedPath } from '@shared/constants/routes.constants';

export const RecordingRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const isAuth = useAppSelector(selectors.getAccessToken);

  const { data, isError, isLoading, isSuccess } = useCallRecordingControllerGetCallRecordingQuery(
    { id: id! },
    { skip: !id || !isAuth },
  );

  if (!isAuth) {
    return <Navigate to="/sign-in" replace />;
  }

  if (!id || isError || (isSuccess && !data?.url)) {
    return <Navigate to={AuthenticatedPath.CAMPAIGN} replace />;
  }

  if (isLoading || !isSuccess) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <RecordingPreview
      callId={id}
      onClose={() => navigate(AuthenticatedPath.CAMPAIGN, { replace: true })}
    />
  );
};
